"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuoteCurrencyFormatter = void 0;
var react_1 = require("react");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var useProjectCurrency_1 = require("./useProjectCurrency");
var currency_formatter_1 = __importDefault(require("currency-formatter"));
var GetDecimalPlaces_1 = require("@CommonFrontend/Utils/GetDecimalPlaces");
var useWidgetCurrencyFormat_1 = require("./useWidgetCurrencyFormat");
var useQuoteCurrencyFormatter = function () {
    var _a = (0, useProjectCurrency_1.useProjectCurrency)(), currencyCode = _a.currencyCode, locale = _a.locale, projectCurrencyFormat = _a.currencyFormat;
    var projectShowDecimals = projectCurrencyFormat.showDecimals;
    var widgetCurrencyFormat = (0, useWidgetCurrencyFormat_1.useMaybeWidgetCurrencyFormat)();
    var showDecimalPlaces = widgetCurrencyFormat && widgetCurrencyFormat.type === "custom"
        ? widgetCurrencyFormat.showDecimals
        : projectShowDecimals;
    return (0, react_1.useMemo)(function () {
        var format = function (value, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.round, round = _c === void 0 ? true : _c;
            var decimalPlaces = 0;
            var idealDecimalPlaces = currency_formatter_1.default.findCurrency(currencyCode).decimalDigits;
            var actualDecimalPlaces = (0, GetDecimalPlaces_1.getDecimalPlaces)(value);
            if (!showDecimalPlaces && actualDecimalPlaces === 0) {
                decimalPlaces = 0;
            }
            else if (!round && actualDecimalPlaces > idealDecimalPlaces) {
                decimalPlaces = actualDecimalPlaces;
            }
            else {
                decimalPlaces = idealDecimalPlaces;
            }
            return (0, FormatCurrency_1.formatCurrency)(value, currencyCode, decimalPlaces, locale);
        };
        var parse = function (value) {
            return (0, FormatCurrency_1.parseCurrency)(value, currencyCode, { locale: locale });
        };
        var currencySymbol = currency_formatter_1.default.findCurrency(currencyCode).symbol;
        return { format: format, parse: parse, currencySymbol: currencySymbol };
    }, [currencyCode, locale, showDecimalPlaces]);
};
exports.useQuoteCurrencyFormatter = useQuoteCurrencyFormatter;
